import { colors } from 'styles/colors';

type CheckProps = {
  color?: string;
  size?: string;
};

export const Check = ({ size = '24', color = colors.White }: CheckProps): JSX.Element => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 6L9 17L4 12" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
